import React from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap'
import { useEffect } from "react";

function VideoGame() {

    const Porfolio = [
        { P: 'Run Or Die', L: '/run-or-die',  C: 'image runordie' }
    ];

    useEffect(() => {
        gsap.from('.card',
            {
                duration: 0.1,
                scale: 0,
                stagger: 0.1,
                opacity: 0
            })
    }, []);

    return (
        <React.Fragment>
            <section>

                <h2 className="">Video Games</h2>
                

                <div className='listPorfolio'>
                    {Porfolio.map(pro => (
                        <Link key={pro.P} to={pro.L} >

                            <div className='card'>
                                <div className='card-image'> <div className={pro.C}></div> </div>
                                <p className='card-title'> {pro.P} </p>
                            </div>
                        </Link>


                    ))}
                </div>
                <div className='after'>
                    <Link to="/other-proyects" className="Link">  <div className='iconAfter'>  <p className='flechaProyect'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default VideoGame;